export class Login {
	static readonly type = '[Auth] Login';
	constructor(public netId: string, public password: string) {}
}

export class Logout {
	static readonly type = '[Auth] Logout';
}

export class SetErrorMessage {
	static readonly type = '[Auth] SetErrorMessage';
	constructor(public errorMessage: string) {}
}

export class ClearErrorMessage {
	static readonly type = '[Auth] ClearErrorMessage';
}

export class GoToLoginWithRedirect {
	static readonly type = '[Auth] GoToLoginWithRedirect';
	constructor(public redirectUrl: string) {}
}
